// removed by extract-text-webpack-plugin
module.exports = {"item":"_2voG4dug0 gnqizMKgM"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/promo-code-list/promo-code-list-empty/promo-code-list-empty.css
 ** module id = 2151
 ** module chunks = 0
 **/